import axios from 'axios'

export const MyApiClient = axios.create({
  // (1). DEVELOP : Tom's notbook
  // baseURL: 'http://localhost/mlab/src/service/',
  // xsrfCookieName: 'csrftoken',
  // xsrfHeaderName: 'X-CSRFToken',
  // timeout: 0

  // (2). Use for Production : http (WORK)
  baseURL: 'http://www.labsmartsoft.com/mlab/service/',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: 3000
})
